import axios from 'axios';

/**
 * http request 보내는 object
 * @typedef {Object} obj
 * @param {string} url - request url
 * @param {('GET'|'POST'|'HEAD'|'DELETE'|'OPTIONS'|'PUT'|'CONNECT'|'TRACE'|'PATCH')} method - http request methpod
 * @param {Object} header - request header
 * @param {any} data - request body
 * @param {boolean} [auth=false] - include authorization token
 */
function httpClient({ url, method, header, data, auth = false }) {
  const userInfo = JSON.parse(sessionStorage.getItem('login_info'));
  const { user_token: token } = userInfo || '';

  // TODO: 현재 유저 정보를 URL 끝에 넣어 보내는중 나중에 헤더로 변경 예정
  return axios({
    url: `${url}${auth ? `/${token}` : ''}`,
    method,
    headers: header,
    data,
  });
}

export default httpClient;
